<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <form @submit.prevent="store('')" class="form-content">
        <div class="form-content-inner">

            <div class="form-col">
                <field :label="$t('Name')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <control type="text" v-model="contractfile.name"/>
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('File')" class="w-full md:w-2/2 px-3 mb-6 md:mb-0">
                    <input type="file" accept="image/*, application/pdf" v-on:change="onFileChange" class="form-control-file" id="my-file" />
                </field>
            </div>

            <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                    <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import axios from 'axios'
import { axiosDocument } from "@/boot/axios";
import { mdiBallot, mdiCheckBold, mdiClose } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
import Loading from 'vue-loading-overlay'
export default {
    name: 'ClassForm',
    components: {
        Field,
        Datepicker,
        Control,
        JbButton,
        JbButtons,
        Loading
    },
    props: {
        showEdit: { Boolean },
        propObject: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    data: function () {
        return {
        }
    },
    emits: ['close-modal', 'is-new', 'submit', 'refresh-list'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)
        const toast = useToast()
        const router = useRouter()

        const errors = ref([])

        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const contractfile = reactive({
            id: '',
            employee_id: '',
            employee_contract_id: '',
            name: '',
            file: '',
            created_by: '',
            updated_by: ''
        })

        const image = ref('')
        const preview = ref('')
        const onFileChange = async (event) => {
            const file = event.target.files[0]
            if (file) {
                if (file.size > 1024 * 1024) {
                    alert('File too big (> 1MB)')
                    var es = document.forms[1].elements;
                    es[0].value = "";
                    document.getElementById("my-file").value = null;
                } else {
                    const reader = new FileReader()
                        reader.onloadend = function () {
                        preview.value = reader.result
                    }

                    image.value = file
                    reader.readAsDataURL(file)
                }
            } else {
                preview.value = ''
                image.value = ''
            }
        }

        const store = async (env) => {
            isLoading.value = true
            const url = props.showEdit ? 'employeecontract-file/' + contractfile.id : 'employeecontract-file';
            const method = props.showEdit ? "PUT" : "POST";

            contractfile.file = preview.value
            contractfile.created_by = userlogin
            console.log('contractfile', contractfile)

            const jsonData = JSON.stringify(contractfile)

            const configHeaders = {
                "content-type": "application/json",
                "Accept": "application/json"
            };

            await axios({
                    method,
                    url,
                    data: jsonData,
                    headers: configHeaders
                })
                .then(response => {
                    isLoading.value = false
                    if (response.data.success) {
                        document.getElementById("my-file").value = null;
                        preview.value = ''
                        image.value = ''

                        emit('close-modal')
                        emit('refresh-list')
                        toast.success(response.data.message)
                    } else {
                        errors.value = response.data.message
                        toast.error(response.data.message)
                    }
                })
                .catch(error => {
                    isLoading.value = false
                    console.log(error)
                })
        }

        onBeforeMount(() => {
        })

        onMounted(() => {
        })

        watchEffect(() => {
            const newobject = props.propObject;
            Object.assign(contractfile, newobject);

            if (!props.showEdit) {
                contractfile.id = null;
                contractfile.name = null;
                contractfile.file = null;
            }
        })
        
        return {
            // File
            image,
            preview,
            onFileChange,

            titleStack,
            mdiBallot,
            mdiCheckBold,
            mdiClose,
            router,
            contractfile,
            store,
            toast,
            userlogin,
            errors,
            isLoading
        }
    },
    methods: {
    }
}
</script>
